export const reLocalityTypeConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_LOCALITY_TYPE_SUCCESS',
		REQUEST : 'GET_PAGED_LOCALITY_TYPE_REQUEST',
		FAILURE : 'GET_PAGED_LOCALITY_TYPE_FAILURE'
	},
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_LOCALITY_TYPE_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_LOCALITY_TYPE_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_LOCALITY_TYPE_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_LOCALITY_TYPE_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_LOCALITY_TYPE_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_LOCALITY_TYPE_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_LOCALITY_TYPE_REQUEST',
		SUCCESS : 'GET_LIST_LOCALITY_TYPE_SUCCESS',
		FAILURE : 'GET_LIST_LOCALITY_TYPE_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_LOCALITY_TYPE_REQUEST',
		SUCCESS : 'CREATE_LOCALITY_TYPE_SUCCESS',
		FAILURE : 'CREATE_LOCALITY_TYPE_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_LOCALITY_TYPE_REQUEST',
		SUCCESS : 'DELETE_LOCALITY_TYPE_SUCCESS',
		FAILURE : 'DELETE_LOCALITY_TYPE_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_LOCALITY_TYPE_REQUEST',
		SUCCESS : 'UPDATE_LOCALITY_TYPE_SUCCESS',
		FAILURE : 'UPDATE_LOCALITY_TYPE_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_LOCALITY_TYPE_REQUEST',
		SUCCESS : 'RESTORE_LOCALITY_TYPE_SUCCESS',
		FAILURE : 'RESTORE_LOCALITY_TYPE_FAILURE'
	},
	CLEAR: 'CLEAR_LOCALITY_TYPE'
}